import React from "react";
import "./App.scss";
import "./i18n";
import Main from "./containers/Main";
import {LanguageProvider} from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div>
        <Main />
      </div>
    </LanguageProvider>
  );
}

export default App;
